export default __webpack_public_path__ + "static/media/bhd.a12077eb.png";